import { AppLanguage } from 'AppTypes'

export const convertIntegerToOrdinalNumber = (number: number|string|undefined, appLanguage: AppLanguage = 'jp'): string => {
  // https://stackoverflow.com/questions/13627308/add-st-nd-rd-and-th-ordinal-suffix-to-a-number
  if (!number || (typeof number === 'string' && Number.isNaN(parseInt(number, 10)))) {
    return 'n/a'
  }

  if (appLanguage === 'en') {
    if (typeof number === 'string') number = parseInt(number, 10)

    const remainder10 = number % 10
    const remainder100 = number % 100

    if (remainder10 === 1 && remainder100 !== 11) return `${number}st`
    if (remainder10 === 2 && remainder100 !== 12) return `${number}nd`
    if (remainder10 === 3 && remainder100 !== 13) return `${number}rd`

    return `${number}th`
  }

  return `${number}`
}

export const getOrdinalSuffix = (number: number|string|undefined, appLanguage: AppLanguage = 'jp'): string => {
  if (!number || (typeof number === 'string' && Number.isNaN(parseInt(number, 10)))) {
    return ''
  }

  if (appLanguage === 'en') {
    if (typeof number === 'string') number = parseInt(number, 10)

    const remainder10 = number % 10
    const remainder100 = number % 100

    if (remainder10 === 1 && remainder100 !== 11) return 'st'
    if (remainder10 === 2 && remainder100 !== 12) return 'nd'
    if (remainder10 === 3 && remainder100 !== 13) return 'rd'

    return 'th'
  }

  return ''
}

export const formatNumber = (number: number, appLanguage: AppLanguage = 'jp'): string => {
  const locale = appLanguage === 'jp' ? 'ja-JP' : 'en-IN'
  return new Intl.NumberFormat(locale).format(number)
}
